import { render, staticRenderFns } from "./PackageCustomFieldsTab.vue?vue&type=template&id=d4a1b0c6&scoped=true"
import script from "./PackageCustomFieldsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackageCustomFieldsTab.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PackageCustomFieldsTab.vue?vue&type=style&index=0&id=d4a1b0c6&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a1b0c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4a1b0c6')) {
      api.createRecord('d4a1b0c6', component.options)
    } else {
      api.reload('d4a1b0c6', component.options)
    }
    module.hot.accept("./PackageCustomFieldsTab.vue?vue&type=template&id=d4a1b0c6&scoped=true", function () {
      api.rerender('d4a1b0c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Tabs/PackageCustomFieldsTab.vue"
export default component.exports